import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import styles from './VNCategoryPill.module.scss'
import { ButtonBase } from '@material-ui/core'
import { GRAY_COLOR, SHIFT4_BLUE, WHITE_COLOR } from '../../styles/constants'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedCategory } from '../ActionCreators'
import { FAVORITES_ID, getSelectedCategory } from '../Selectors'
import { isColorTooLight } from '../../VNUtil/VNUtils'
import { isE700Device } from '../../VNAndroidSDK/Utils'

const VNCategoryPill = ({ category = {} }) => {
  const categoryRef = useRef()
  const dispatch = useDispatch()
  const categoryId = useMemo(() => category.itemCategoryUuid || category.id, [category])
  const selectedCategory = useSelector(getSelectedCategory)
  const isSelected = useMemo(() => categoryId === selectedCategory, [categoryId, selectedCategory])
  const style = useMemo(() => {
    if (!isSelected) return

    const backgroundColor = category.color || SHIFT4_BLUE
    const useWhiteText = !isColorTooLight(backgroundColor)
    return { backgroundColor, color: useWhiteText ? WHITE_COLOR : GRAY_COLOR }
  }, [category, isSelected])

  useEffect(() => {
    if (selectedCategory === FAVORITES_ID) return
    if (isSelected && categoryRef.current) {
      categoryRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClick = useCallback(() => {
    dispatch(setSelectedCategory(categoryId))
  }, [dispatch, categoryId])

  return (
    <ButtonBase
      disableRipple={isE700Device()}
      component="div"
      className={styles.container}
      style={style}
      onClick={handleClick}
      ref={categoryRef}
    >
      <div className={styles.content}>{category.name}</div>
    </ButtonBase>
  )
}

export default VNCategoryPill
